import LoLButton, { LoLButtonProps } from './LoLButton';

export default LoLButton;
export type { LoLButtonProps };
